module.exports = __webpack_public_path__ + "img/genom_3.b097a7f7.png";